import classNames from "classnames";
import { fill } from "@helpers/common";

export const SkeletonCircle = ({ className, style }) => (
  <div
    className={classNames("skeleton rounded-circle flex-shrink-0", className)}
    style={style}
  />
);

export const SkeletonBlock = ({ className, children }) => (
  <div className={classNames("skeleton", className)}>{children}</div>
);

export const SkeletonBlocks = ({ className, blockClassName, count = 1 }) => (
  <div className={className}>
    {fill(count).map((_, key) => (
      <SkeletonBlock key={key} className={blockClassName} />
    ))}
  </div>
);

export const SkeletonText = ({ className, lineClassName, lines = 1 }) => (
  <div className={classNames("d-flex flex-column w-100", className)}>
    {fill(lines).map((_, key) => (
      <div
        className={classNames("skeleton skeleton-text w-100", lineClassName)}
        key={key}
      />
    ))}
  </div>
);
